export default __webpack_public_path__ + "static/media/bg-featured-mb.a16a88d9.png";